export const ANALYSIS_VERSION = "engine-health-analysis/v23";

export type ScoreClass = "muted" | "green" | "amber" | "red";
export type ScoreCardState = "" | "is-watch" | "is-review";

// Severity ladder (alarm redesign): Normal / Watch / Attention. A single flight's
// metric is either in family or it isn't — "Normal" states that without grading the
// engine; "Attention" replaces the retired "Review" band word. The is-review CSS
// state key below is unchanged (class names are not user-facing vocabulary).
export function scoreLabel(score: number): string {
  if (!Number.isFinite(score)) return "No data";
  if (score >= 88) return "Normal";
  if (score >= 72) return "Watch";
  return "Attention";
}

export function scoreClass(score: number): ScoreClass {
  if (!Number.isFinite(score)) return "muted";
  if (score >= 88) return "green";
  if (score >= 72) return "amber";
  return "red";
}

export function scoreCardStateFromClass(className: string): ScoreCardState {
  if (className === "red") return "is-review";
  if (className === "amber") return "is-watch";
  return "";
}

export function scoreCardState(score: number): ScoreCardState {
  return scoreCardStateFromClass(scoreClass(score));
}
